import { render, staticRenderFns } from "./addCityArea.vue?vue&type=template&id=03f58cdc&scoped=true"
import script from "./addCityArea.vue?vue&type=script&lang=js"
export * from "./addCityArea.vue?vue&type=script&lang=js"
import style0 from "./addCityArea.vue?vue&type=style&index=0&id=03f58cdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f58cdc",
  null
  
)

export default component.exports